<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <div class="mainBody">
            <div class="searchBox">
                <div class="searchGroup">
                    <label>孔号：</label>
                    <el-input v-model="search_Obj.f_hole_code" clearable @keyup.enter.native="doSearch"></el-input>
                </div>
                <div class="searchGroup">
                    <label>作业方式：</label>
                    <el-select v-model="search_Obj.f_work_type" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                        <el-option v-for="item in enuObj('work_type_int')" :key="'work_type_int'+item.key" :label="item.title" :value="item.key"> </el-option>
                    </el-select>
                </div>
                <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            </div>
            <div class="dataBox">
                <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                    <el-table-column prop="hole_code" label="孔号" sortable="custom"></el-table-column>
                    <el-table-column prop="segment_no" label="段号" sortable="custom"></el-table-column>
                    <el-table-column prop="segment_no" label="作业方式" sortable="custom">
                        <template slot-scope="scope">
                            <span>{{ transEnu(scope.row.work_type, "work_type_int") }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="add_time" label="记录时间" sortable="custom"></el-table-column>
                    <el-table-column label="操作" width="120" align="center" v-if="save_type==1">
                        <template slot-scope="scope">
                            <el-button  size="mini" plain type="primary" @click="info(scope.row.id)">选择</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="180" align="center" v-if="save_type==2">
                        <template slot-scope="scope">
                            <el-button  size="mini" plain type="primary" @click="info(scope.row.id)">选择</el-button>
                            <el-button  size="mini" plain type="danger" @click="del(scope.row.id)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pageBox">
                <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import listutil from "@/libs/listutil"
import { delOcrLog } from '@/api/ocrlog'

export default {
    name: 'ocrLogList',
    mixins: [listutil],
    props: {
        isshow: {
            type: Boolean,
            default() {
                return false;
            }
        },
        width: {
            type: String,
            default() {
                return '800px';
            }
        },
        title: {
            type: String,
            default() {
                return ""
            }
        },
        save_type: {
            type: Number,
            default() {
                return 1
            }
        },
    },
    watch: {
        isshow(newv, old) {
            this.showflag = newv;
            if (newv) {
                this.search_Obj.f_save_type = this.save_type;
                this.getData()
            }
        }
    },
    data() {
        return {
            showflag: false,
            m_name: 'OCR识别记录',
            menu_id: 9999,
            list_url: "/api/admin/ocrlog/list",
            search_Obj: {
                f_save_type: '',
                f_hole_code: '',
                f_work_type: '',
            },
            del_Obj:{
                url:'/api/admin/ocrlog/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['work_type_int'],
        };
    },
    methods: {
        closeDialog(){
            this.$emit("on-close")
        },
        info(id){
            this.$emit("on-select-log", id)
        },
        del(id){
            this.$confirm('确定要删除该条数据吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                delOcrLog(id).then(res=>{
                    if(res.code ==1){
                        this.$msg("删除成功")
                        this.getListData();
                    }else{
                        this.$msg(res.msg)
                    }
                })
            }).catch(() => { })
        },
    }
};
</script>